import crudApi from "@serie3/common/api/crudApi";
import apiClient from "@serie3/common/api/client";
import PipelineConfig from "../../Config/Crm/PipelineConfig";

const extractArray = (res, ...fields) => {
  const d = res?.data;
  if (!d) return [];
  if (Array.isArray(d)) return d;
  for (const f of fields) if (Array.isArray(d[f])) return d[f];
  return [];
};

const getProjects = async () => {
  const res = await crudApi.justGet(PipelineConfig.project.getAll);
  return extractArray(res, "projects", "items", "kunden");
};

const createProject = (data) =>
  crudApi.createNew(PipelineConfig.project.new, JSON.stringify(data, null, 2));

const editProject = (data) =>
  crudApi.edit(PipelineConfig.project.edit, JSON.stringify(data, null, 2));

const deleteProject = (id) =>
  crudApi.del(PipelineConfig.project.delete, id);

const getSteps = async (projectId) => {
  const res = await crudApi.justGet(PipelineConfig.step.byProject + projectId);
  return extractArray(res, "steps", "items");
};

const createStep = (data) =>
  crudApi.createNew(PipelineConfig.step.new, JSON.stringify(data, null, 2));

const editStep = (data) =>
  crudApi.edit(PipelineConfig.step.edit, JSON.stringify(data, null, 2));

const deleteStep = (id) =>
  crudApi.del(PipelineConfig.step.delete, id);

const reorderStep = (id, prevId, nextId) =>
  apiClient.post(`${PipelineConfig.step.reorder}${id}/${prevId}/${nextId}`);

const getEntries = async (projectId) => {
  const res = await crudApi.justGet(PipelineConfig.entry.byProject + projectId);
  return extractArray(res, "entries", "items");
};

const createEntry = (data) =>
  crudApi.createNew(PipelineConfig.entry.new, JSON.stringify(data, null, 2));

const editEntry = (data) =>
  crudApi.edit(PipelineConfig.entry.edit, JSON.stringify(data, null, 2));

const deleteEntry = (id) =>
  crudApi.del(PipelineConfig.entry.delete, id);

export default {
  getProjects, createProject, editProject, deleteProject,
  getSteps, createStep, editStep, deleteStep, reorderStep,
  getEntries, createEntry, editEntry, deleteEntry,
};
